import script from "./CameraItemPane.vue?vue&type=script&lang=ts&setup=true"
export * from "./CameraItemPane.vue?vue&type=script&lang=ts&setup=true"

import "./CameraItemPane.vue?vue&type=style&index=0&id=53832a46&scoped=true&lang=scss"

import exportComponent from "/github/workspace/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53832a46"]])

export default __exports__